<template>
  <div id="toolbar">
    <b-img
      left
      :src="require('@/assets/stryker_logo_small.png')"
      height="40px"
      width="auto"
      alt="Stryker Logo"
    />
    <div id="user" v-if="$msal.isAuthenticated()">
      <b-dropdown id="idUserDropdown" variant="outline-dark" right>
        <template v-slot:button-content>
          <font-awesome-icon size="lg" icon="user-circle" />
        </template>
        <b-dropdown-header>User Profile</b-dropdown-header>
        <b-dropdown-text id="idToolbarName">{{
          $msal.data.user.name
        }}</b-dropdown-text>
        <b-dropdown-text id="idToolbarEmail">{{
          $msal.data.user.userName
        }}</b-dropdown-text>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-group header="User Roles">
          <b-dropdown-text v-for="role in this.userRoles" :key="role">{{
            role
          }}</b-dropdown-text>
        </b-dropdown-group>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-header>MakoSuite Version</b-dropdown-header>
        <b-dropdown-text id="idToolbarVersion">{{ $version }}</b-dropdown-text>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-header>Actions</b-dropdown-header>
        <b-dropdown-item-button id="idToolbarLogOut" @click="handleLogout"
          >Log Out</b-dropdown-item-button
        >
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  methods: {
    handleLogout() {
      sessionStorage.clear();
      clearInterval(this.$store.state.refreshIntervalHandler);
      this.$router.push({ name: "msLogout" });
    },
  },
  computed: {
    userRoles() {
      // Get all roles and translate to display name
      return (
        this.$store.state.roles
          ?.map((role) => {
            if (role === "RH.MS.FieldUser")
              return "MakoSuite Field and MPS User";
            else if (role === "RH.MS.AdminUser")
              return "MakoSuite Business Administration User";
            else if (role === "RH.MS.InhouseUser")
              return "MakoSuite In-house Segmentation-Team User";
            else if (role === "RH.MS.SolidUser") return "SOLID Insights User";
          })
          // remove all not recognized roles
          .filter((role) => {
            return role != null;
          })
      );
    },
  },
};
</script>

<style scoped>
#toolbar {
  font-size: 0.9rem;
  background-color: #ffb500;
  width: 100%;
  height: 50px;
}

img {
  margin: 0.4rem 1.5rem;
}

#user {
  float: right;
  margin: 10px 20px;
}
.dropdown-menu {
  min-width: 40rem !important;
}
.dropdown-toggle {
  padding: 0rem !important;
  margin: 0rem !important;
}

.dropdown-header {
  padding-top: 0;
  padding-bottom: 0;
}
</style>